var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWeblink = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.01 50.01",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.89 17.61a25 25 0 1 0-.24 15.52 25 25 0 0 0 .24-15.52Zm-3.88 7.38a20 20 0 0 1-.88 6h-6.76a26.65 26.65 0 0 0 .14-11h6.81a19.21 19.21 0 0 1 .69 5Zm-20 16.66a19.1 19.1 0 0 1-5.07-5.74h10.15a18.94 18.94 0 0 1-5.08 5.65Zm-7.14-10.73a21.48 21.48 0 0 1-.19-11h14.76a21.37 21.37 0 0 1-.24 11Zm-11.86 0a20.26 20.26 0 0 1-.88-5.84 19.42 19.42 0 0 1 .65-5.09h6.81a26.65 26.65 0 0 0 .07 11Zm19-22.4a18.9 18.9 0 0 1 5.48 6.47H19.54a19 19 0 0 1 5.47-6.57Zm17.24 6.47h-6.24a25.32 25.32 0 0 0-6.69-9.38h.12a20.05 20.05 0 0 1 12.78 9.29Zm-21.69-9.4h.12a25.15 25.15 0 0 0-6.67 9.4H7.78a20 20 0 0 1 12.78-9.5ZM8.23 35.82h6.07a25 25 0 0 0 6.38 8.69h-.14a20.19 20.19 0 0 1-12.31-8.69Zm21.24 8.66h-.15a24.79 24.79 0 0 0 6.41-8.66h6.09a20.11 20.11 0 0 1-12.35 8.66Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWeblink);
export default ForwardRef;